module.exports = __webpack_public_path__ + "img/left-border.7eeb676c.png";